

import { useState } from 'react';
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadJournalEntry = async (action) => {
  try {
    switch (action) {
      case 'new':
        let request = await Axois.get('/setups/entries');
        let requestResponseData = await request.data;
        return {...requestResponseData, entry: {}};
      default:
        let response = await Axois.get('entries/v2/entry/'+action)
        let responseData = await response.data;
        return responseData;
    }
  }catch (err) {
    console.log(err);
  }
};


export const loadJournalItems = async () => {
  try {
    let response = await Axois.get('entries/v2/all');
    let responseData = await response.data;
    return responseData;
  }catch (err) {
    console.log(err);
  }
}

export const loadJournalItemsType = async (type) => {
  try {
    let response = await Axois.get('entries/v2/journal/'+type);
    let responseData = await response.data;
    return responseData;
  }catch (err) {
    console.log(err);
  }
}



const useJournalEntriesAPI = () => {


  const createEntry = async (data, success, error) => {
    // success('entry created successfully!');
    // EventEmitter.dispatch('createEntryResponseCode', 'AIOFS');
    try {
      const response = await Axois.post('entries/create/v2', {entry: data});
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('createEntryResponseCode', responseData.code);
    }catch (err) {
      EventEmitter.dispatch('entry_error', err.response.data.message);
    }
  }

  const postEntry = async (number, data, success, error) => {
    try {
      const response = await Axois.post('entries/v2/post-entry/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('posted-entry', responseData.number);
    }catch(err) {
      EventEmitter.dispatch('entry_error', err.response.data.message);
    }
  }

  const resetEntry = async (number, data, success) => {
    try {
      const response = await Axois.patch('entries/v2/reset-entry/'+number.replaceAll('/', '-'), data);
      const responseData = await response.data
      success(responseData.message);
      EventEmitter.dispatch('reset-entry', responseData.status);
    }catch (err) {
      EventEmitter.dispatch('entry_error', err.response.data.message);    }
  }


  return { createEntry, postEntry, resetEntry };
}


export default useJournalEntriesAPI;